<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog> <!-- Added ConfirmDialog here -->
<router-outlet></router-outlet>
<app-cookie-dialog #cookieContext></app-cookie-dialog>